var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{attrs:{"colspan":"1","rowspan":"1"},on:{"click":_vm.sortValue}},[_c('div',{staticClass:"vs-table-text"},[_vm._t("default"),(_vm.sortKey)?_c('span',{staticClass:"sort-th"},[_c('vs-icon',{staticClass:"th-sort-icon",attrs:{"icon":_vm.sortIcon}})],1):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }